import { z } from "zod";

import { DatabaseIdentity } from "@/core/api";
import { DateIsoString } from "@/core/types";
import { AttachmentLike } from "@/data/attachments";
import { PublicProfile } from "@/data/public-profiles/types/PublicProfile";

export const NewsItem = z
  .object({
    publicProfileName: z.string().optional(),
    publicProfileLogo: AttachmentLike.optional(),
    status: z.string().optional(),
    publicationDate: DateIsoString,
    createdDate: DateIsoString.optional(),
    modifiedDate: DateIsoString.optional(),
    title: z.string(),
    shortText: z.string().nullable(),
    longText: z.string(),
    longFlavorText: z.string(),
    coverImage: AttachmentLike,
    publicProfile: PublicProfile,
  })
  .merge(DatabaseIdentity);

export type NewsItem = z.infer<typeof NewsItem>;
